<template>
  <div>
    <el-table v-loading="loading" :data="rows" border style="width: 100%" highlight-current-row>
      <el-table-column label="姓名" width="150" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="openDetail(scope.row)">
            {{ scope.row.studentname }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column prop="cardid" label="身份证号码" min-width="180" align="center" />
      <el-table-column prop="models" label="驾照类型" min-width="80" align="center" />
      <el-table-column prop="schoolname" label="驾校名称" min-width="120" align="center" />
      <el-table-column label="科一学时" min-width="130" align="center">
        <template slot-scope="scope">
          <div>{{ formatHours(scope.row.subjectOneSeconds) }}h</div>
          <div class="reported-text">已上报 {{ formatHours(scope.row.subjectOneReportedSeconds) }}h</div>
        </template>
      </el-table-column>
      <el-table-column label="科四学时" min-width="130" align="center">
        <template slot-scope="scope">
          <div>{{ formatHours(scope.row.subjectFourSeconds) }}h</div>
          <div class="reported-text">已上报 {{ formatHours(scope.row.subjectFourReportedSeconds) }}h</div>
        </template>
      </el-table-column>
      <el-table-column label="上报状态" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tag :type="reportStatusType(scope.row.lastReportStatus)">
            {{ reportStatusLabel(scope.row.lastReportStatus) }}
          </el-tag>
          <div v-if="scope.row.pendingReportCount" class="pending-text">
            待同步 {{ scope.row.pendingReportCount }} 条
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="lastActivityTime" label="最近学习" min-width="160" align="center" />
      <el-table-column label="操作" width="172" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" @click="openManualStudy(scope.row)">添加记录</el-button>
          <el-button type="primary" size="mini" @click="openDetail(scope.row)">学习详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <Pagination :total="total" :page-size="pageSize" @currentChange="handlePageChange" />

    <el-dialog title="摩托车学习详情" :visible.sync="detailVisible" width="90%" top="50px">
      <MotorcycleLearningDetail v-if="detail.student" :detail="detail"
                                ref="motorcycleLearningDetail"
                                @refresh="refreshAfterReport" />
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/pagination'
import MotorcycleLearningDetail from '@/components/system/MotorcycleLearningDetail.vue'
import {
  motorcycleDetail,
  motorcycleStudentList
} from '@/api/motorcycleLearning'
import { formatHours, reportStatusLabel, reportStatusType } from '@/utils/motorcycleLearning'

export default {
  name: 'MotorcycleStudentLearningTable',
  components: { Pagination, MotorcycleLearningDetail },
  props: {
    cardid: { type: String, default: '' },
    name: { type: String, default: '' }
  },
  data () {
    return {
      rows: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      detailVisible: false,
      detail: {},
      currentUserId: null
    }
  },
  methods: {
    formatHours,
    reportStatusLabel,
    reportStatusType,
    async search () {
      this.page = 1
      await this.loadData()
    },
    async loadData () {
      this.loading = true
      try {
        const res = await motorcycleStudentList({
          keyword: this.cardid || this.name,
          page: this.page,
          size: this.pageSize
        })
        this.rows = res.data
        this.total = res.count
      } finally {
        this.loading = false
      }
    },
    async handlePageChange (page) {
      this.page = page
      await this.loadData()
    },
    async openDetail (row) {
      this.currentUserId = row.uid
      const res = await motorcycleDetail({ userId: row.uid })
      this.detail = res.data
      this.detailVisible = true
    },
    async openManualStudy (row) {
      await this.openDetail(row)
      this.$nextTick(() => this.$refs.motorcycleLearningDetail.focusManualStudy())
    },
    async exportCsv () {
      const res = await motorcycleStudentList({
        keyword: this.cardid || this.name,
        page: 1,
        size: 10000
      })
      const headers = ['UID', '姓名', '身份证', '学员编号', '驾校', '车型', '科一学时', '科四学时', '监管状态']
      const lines = res.data.map(row => [
        row.uid, row.studentname, row.cardid, row.studentno, row.schoolname, row.models,
        formatHours(row.subjectOneSeconds), formatHours(row.subjectFourSeconds),
        reportStatusLabel(row.lastReportStatus)
      ].map(this.csvValue).join(','))
      const blob = new Blob(['\uFEFF' + [headers.join(','), ...lines].join('\n')], { type: 'text/csv;charset=utf-8' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `摩托车学习_${Date.now()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    },
    csvValue (value) {
      const text = String(value == null ? '' : value).replace(/"/g, '""')
      return `"${text}"`
    },
    async refreshAfterReport () {
      await this.loadData()
      await this.refreshDetail()
    },
    async refreshDetail () {
      if (!this.detailVisible || !this.currentUserId) return
      const res = await motorcycleDetail({ userId: this.currentUserId })
      this.detail = res.data
    }
  }
}
</script>

<style lang="less" scoped>
.reported-text { color: #67c23a; font-size: 12px; margin-top: 4px; }
.pending-text { color: #e6a23c; font-size: 12px; margin-top: 4px; }
</style>
